import AbstractApiModel from '@/models/abstracts/AbstractApiModel';

/**
 * POST /team_member_status_histories {teamMember, teamMemberStatus} : retrait d'un employé de l'équipe (Inactif, trace
 * conservée) ou retour (Actif, mêmes règles qu'à l'ajout), par un Dirigeant de la société ; historisé
 */
export default class TeamMemberStatusHistoryModel extends AbstractApiModel {
  protected _path = '/team_member_status_histories/{?id}';
}
